/* eslint-disable */
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//import url and gateway methods
import { getData} from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { vitalsOptions } from "data/medical/vitals";
import { durationOptions } from "data/medical/consentduration"; 

const PatientViewConsentPopup = ({ isOpen = false, onClose = () => {}, selectedConsentId = null }) => {

    const { t } = useTranslation();
    const token = localStorage.getItem("token");
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));

    const currentUserId = userInfo ? userInfo._id : null;

    const [consentData, setConsentData] = useState(null);
    const [consentOwnerId, setConsentOwnerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [approveLoading, setApproveLoading] = useState(false);

    // Get consent details and map API data
    const getConsentDetails = async () => {
        try {
            setLoading(true);
            let requestUrl =
                url.API_BASE_URL +
                url.API_GET_MEDICAL_CONSENT_DETAILS +
                `/${selectedConsentId}` +
                `?token=${token}`;

            console.log('Consent detailsRequest URL:', requestUrl);

            const response = await getData(requestUrl);

            console.log('Consent Details Response:', response);

            if (response.status && response.data) {
                setConsentData(response.data);

                setConsentOwnerId(response.data.ownerid?._id || null);
            }
        } catch (error) {
            console.log(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        console.log('isOpen, selectedConsentId', isOpen, selectedConsentId);
        
        if (isOpen && selectedConsentId) {
            getConsentDetails();
        }
    }, [isOpen, selectedConsentId]);


    const renderElementStatus = (el) => {
        if (el.consentgiven) return { label: "Granted", className: "text-success" };
        if (el.isrejected) return { label: "Rejected", className: "text-danger" };
        return { label: "Pending", className: "text-muted" };
    };

    const handleApproveConsent = async () => {
        try {
            setApproveLoading(true);
            const requestUrl =
                url.API_BASE_URL +
                url.API_MEDICAL_CONSENT_GRANT_ACCESS +
                `/${selectedConsentId}` +
                `?token=${token}`;

            console.log('Approve Consent Request URL:', requestUrl);

            const response = await getData(requestUrl);

            console.log('Approve Consent Response:', response);
            if (response.status) {
                setApproveLoading(false);
                // close the offcanvas using Bootstrap API
                const offcanvasElement = document.getElementById('patientViewConsentOffCanvas');
                if (offcanvasElement) {
                    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
                    if (bsOffcanvas) {
                        bsOffcanvas.hide();
                    }
                }
                onClose();
            }

        } catch (error) {
            console.error("Error approving consent:", error);
            toast.error("An error occurred while approving consent");
        } finally {
            setApproveLoading(false);
        }
    };

    const handleRejectConsent = () => {
        // TODO: Implement reject logic
        console.log("Reject consent:", selectedConsentId);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const getDurationLabel = (duration) => {
        if (!duration) return 'N/A';
        const option = durationOptions.find(opt => opt.value === String(duration));
        return option ? option.label : duration;
    };

    const calculateExpirationDate = (requestDate, duration) => {
        if (!requestDate || !duration) return 'N/A';
        if (duration === '1000') return 'Never (Permanent)';
        
        const request = new Date(requestDate);
        const durationDays = parseInt(duration);
        
        if (isNaN(durationDays)) return 'N/A';
        
        const expiration = new Date(request);
        expiration.setDate(expiration.getDate() + durationDays);
        
        return formatDate(expiration);
    };

    return (
        <div
        className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
        tabIndex="-1"
        id="patientViewConsentOffCanvas"
        aria-labelledby="patientViewConsentOffCanvasLabel"
        >
        <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom">
            <div className="d-flex align-items-center gap-3">
            <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">visibility</span>
            </div>
            <div>
                <h3 className="offcanvas-title fw-bold text-white mb-0" id="patientViewConsentOffCanvasLabel">View Consent Request</h3>
                <p className="text-white fs-sm mb-0 opacity-75">Review consent details and authorization</p>
            </div>
            </div>
            <button
            type="button"
            className="btn-close btn-close-white p-2 rounded-circle shadow-sm border-0"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={onClose}
            ></button>
        </div>

        <div className="offcanvas-body p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "320px", overflowY: "auto" }}>
            {loading ? (
                <div className="mb-4">
                    {/* Loading Skeleton */}
                    <div className="row g-3 mb-3">
                        <div className="col-md-6">
                            <div className="card border-0 shadow-sm h-100">
                                <div className="card-body p-4">
                                    <div className="placeholder-glow">
                                        <div className="placeholder col-6 mb-3 bg-primary opacity-25 rounded"></div>
                                        <div className="placeholder col-4 mb-2 rounded"></div>
                                        <div className="placeholder col-8 mb-3 rounded"></div>
                                        <div className="placeholder col-4 mb-2 rounded"></div>
                                        <div className="placeholder col-10 rounded"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card border-0 shadow-sm h-100">
                                <div className="card-body p-4">
                                    <div className="placeholder-glow">
                                        <div className="placeholder col-6 mb-3 bg-primary opacity-25 rounded"></div>
                                        <div className="placeholder col-4 mb-2 rounded"></div>
                                        <div className="placeholder col-8 mb-3 rounded"></div>
                                        <div className="placeholder col-4 mb-2 rounded"></div>
                                        <div className="placeholder col-10 rounded"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card border-0 shadow-sm mb-3">
                        <div className="card-body p-4">
                            <div className="placeholder-glow">
                                <div className="placeholder col-5 mb-3 bg-primary opacity-25 rounded"></div>
                                <div className="placeholder col-3 me-2 rounded"></div>
                                <div className="placeholder col-4 me-2 rounded"></div>
                                <div className="placeholder col-3 rounded"></div>
                            </div>
                        </div>
                    </div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-4">
                            <div className="placeholder-glow">
                                <div className="placeholder col-6 mb-3 bg-primary opacity-25 rounded"></div>
                                <div className="placeholder col-12 mb-2 rounded" style={{ height: "60px" }}></div>
                                <div className="placeholder col-12 mb-2 rounded" style={{ height: "60px" }}></div>
                                <div className="placeholder col-12 rounded" style={{ height: "60px" }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : !consentData ? (
            <div className="text-center py-5">
                <span className="material-symbols-outlined text-muted mb-3" style={{ fontSize: "48px" }}>description</span>
                <p className="text-muted">No consent requests found.</p>
            </div>
            ) : (
            <div className="mb-4">
                {/* Requested By and Patient Information in One Row */}
                <div className="row g-3 mb-3">
                    {/* Requested By Section */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                                    <span className="material-symbols-outlined">person</span>
                                    Requested By (Doctor/Provider)
                                </h6>
                                <div className="row g-2">
                                    <div className="col-12">
                                        <strong className="text-muted small d-block">Name:</strong>
                                        <span className="fs-6">{consentData.authorizeduserid?.name} {consentData.authorizeduserid?.surname}</span>
                                    </div>
                                    <div className="col-12">
                                        <strong className="text-muted small d-block">Email:</strong>
                                        <span className="fs-6">{consentData.authorizeduserid?.email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Patient Section */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                                    <span className="material-symbols-outlined">patient_list</span>
                                    Authorization asked from (Patient)
                                </h6>
                                <div className="row g-2">
                                    <div className="col-12">
                                        <strong className="text-muted small d-block">Name:</strong>
                                        <span className="fs-6">{consentData.ownerid?.name} {consentData.ownerid?.surname}</span>
                                    </div>
                                    <div className="col-12">
                                        <strong className="text-muted small d-block">Email:</strong>
                                        <span className="fs-6">{consentData.ownerid?.email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Consent Details Section */}
                <div className="card border-0 shadow-sm mb-3">
                    <div className="card-body p-4">
                        <h6 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined">info</span>
                            Consent Details
                        </h6>
                        <div className="d-flex flex-wrap align-items-center gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <strong className="text-muted small">Access Type:</strong>
                                <span className={`badge ${consentData.accesstype === 'partial' ? 'bg-warning' : 'bg-info'} text-dark`}>
                                    {consentData.accesstype === 'partial' ? 'Partial' : 'Full'}
                                </span>
                            </div>
                            <div className="vr"></div>
                            <div className="d-flex align-items-center gap-2">
                                <strong className="text-muted small">Status:</strong>
                                <span className={`badge ${consentData.isapproved ? 'bg-success' : 'bg-secondary'}`}>
                                    {consentData.isapproved ? 'Approved' : 'Pending'}
                                </span>
                            </div>
                            <div className="vr"></div>
                            <div className="d-flex align-items-center gap-2">
                                <strong className="text-muted small">Duration:</strong>
                                <span className="text-dark">{getDurationLabel(consentData.duration)}</span>
                            </div>
                            <div className="vr"></div>
                            <div className="d-flex align-items-center gap-2">
                                <strong className="text-muted small">Requested:</strong>
                                <span className="text-dark">{formatDate(consentData.requestdate)}</span>
                            </div>
                            <div className="vr"></div>
                            <div className="d-flex align-items-center gap-2">
                                <strong className="text-muted small">Approved:</strong>
                                {consentData.isapproved && consentData.approvaldate ? (
                                    <span className="text-dark">{formatDate(consentData.approvaldate)}</span>
                                ) : (
                                    <span className="text-muted">✗</span>
                                )}
                            </div>
                            {consentData.isapproved && (
                                <>
                                    <div className="vr"></div>
                                    <div className="d-flex align-items-center gap-2">
                                        <strong className="text-muted small">Expires:</strong>
                                        <span className="text-dark">{calculateExpirationDate(consentData.approvaldate || consentData.requestdate, consentData.duration)}</span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Consent Elements Section */}
                <div className="card border-0 shadow-sm">
                    <div className="card-body p-4">
                        <h6 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined">checklist</span>
                            Consent Elements {consentData.accesstype !== 'total' && `(${consentData.consentelements?.length || 0})`}
                        </h6>

                        {consentData.accesstype === 'total' && (
                            <div className="alert alert-success d-flex align-items-center gap-3 mb-0" role="alert">
                                <span className="material-symbols-outlined" style={{ fontSize: "32px" }}>verified</span>
                                <div>
                                    <h6 className="mb-1 fw-bold">Total Access</h6>
                                    <p className="mb-0">All associated items related to {consentData.ownerid?.name ?? 'patient'}</p>
                                </div>
                            </div>
                        )}

                        {/* show the consent to the elements */}
                        {consentData.consentelements && consentData.consentelements.length > 0 ? (
                            <div className="row g-3">
                                {consentData.consentelements.map((el, idx) => {
                                    let typeName = '';
                                    let elementName = '';
                                    let iconName = 'description';

                                    switch (el.elementtype) {
                                        case 'treatments':
                                            typeName = 'Treatment';
                                            elementName = el.data?.title;
                                            iconName = 'medical_services';
                                            break;
                                        case 'labReports':
                                            typeName = 'Lab Report';
                                            elementName = el.data?.name;
                                            iconName = 'lab_profile';
                                            break;
                                        case 'prescriptions':
                                            typeName = 'Prescription';
                                            elementName = el.data?.name;
                                            iconName = 'prescriptions';
                                            break;
                                        case 'medicines':
                                            typeName = 'Medication';
                                            elementName = el.data?.productid?.name;
                                            iconName = 'medication';
                                            break;
                                        case 'appointments':
                                            typeName = 'Appointment';
                                            elementName = el.data?.description;
                                            iconName = 'event';
                                            break;
                                        case 'vitals':
                                            typeName = 'Vital Signs';
                                            elementName = vitalsOptions.find(v => v.value === el.elementid)?.label || 'N/A';
                                            iconName = 'monitor_heart';
                                            break;
                                        default:
                                            typeName = 'Unknown';
                                            elementName = 'N/A';
                                            break;
                                    }

                                    const status = renderElementStatus(el);

                                    return (
                                        <div key={idx} className="col-12">
                                            <div className="p-3 bg-light rounded border-start border-4 border-primary">
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="material-symbols-outlined text-primary" style={{ fontSize: "20px" }}>
                                                            {iconName}
                                                        </span>
                                                        <strong className="text-dark">{typeName}</strong>
                                                    </div>
                                                    <span className={`badge ${status.className.replace('text-', 'bg-')}`}>
                                                        {status.label}
                                                    </span>
                                                </div>
                                                <div className="ps-4">
                                                    <small className="text-muted d-block">Element Name:</small>
                                                    <span className="text-dark">{elementName || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center py-3 text-muted">
                                <span className="material-symbols-outlined mb-2" style={{ fontSize: "32px" }}>inbox</span>
                                <p className="mb-0">No consent elements found</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            )}
        </div>
        
        {!loading && consentData && !consentData.isapproved && consentOwnerId === currentUserId && (
            <div className="offcanvas-footer p-3 border-top bg-white d-flex justify-content-between align-items-center">
                <button className="btn btn-outline-secondary" data-bs-dismiss="offcanvas" onClick={onClose}>
                    <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "18px" }}>close</span>
                    Close
                </button>
                
                <div className="d-flex gap-2">
                    {/* <button className="btn btn-danger" onClick={handleRejectConsent}>
                        <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "18px" }}>cancel</span>
                        Reject Consent
                    </button> */}
                    <button className="btn btn-primary" onClick={handleApproveConsent} disabled={approveLoading}>
                        {approveLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm align-middle me-1" role="status" aria-hidden="true"></span>
                                Approving...
                            </>
                        ) : (
                            <>
                                <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "18px" }}>check_circle</span>
                                Approve Consent
                            </>
                        )}
                    </button>
                </div>
                
            </div>
        )}
        </div>
    );
};

export default PatientViewConsentPopup;
